import { render, staticRenderFns } from "./queslist.vue?vue&type=template&id=195f1484&scoped=true"
import script from "./queslist.vue?vue&type=script&lang=js"
export * from "./queslist.vue?vue&type=script&lang=js"
import style0 from "./queslist.vue?vue&type=style&index=0&id=195f1484&prod&lang=scss&scoped=true"
import style1 from "./queslist.vue?vue&type=style&index=1&id=195f1484&prod&lang=scss"
import style2 from "./queslist.vue?vue&type=style&index=2&id=195f1484&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195f1484",
  null
  
)

export default component.exports